import React from 'react';
import '../pages/SitePage.css';

interface TabPanelProps {
  tab: string;
  tabs: any[];
  onChange: Function;
}

interface TabPanelState {
  highlight: boolean[];
}

class TabPanel extends React.Component<TabPanelProps, TabPanelState> {
  protected timer:any;

  constructor(props:TabPanelProps) {
    super(props);
    this.state = {
      highlight: []
    }
  }

  componentDidMount(): void {
    let highlight = Array(this.props.tabs.length).fill(false);
    this.setState({highlight});

    this.updateTabs();
    this.timer = setInterval(() => {
      this.updateTabs();
    }, 250);
  }

  componentWillUnmount(): void {
    clearInterval(this.timer);
  }

  updateTabs() {
    let highlight = [];
    this.props.tabs.forEach((tab:any)=>{
      let h = tab.highlight ? tab.highlight() : false;
      highlight.push(h && (tab.id != this.props.tab));
    });

    if(JSON.stringify(highlight) != JSON.stringify(this.state.highlight)) 
      this.setState({highlight});
  }

  onTab(id:string) {
    let i = this.props.tabs.findIndex((tab:any)=>tab.id == id);

    if(i != -1) {
      let highlight = [...this.state.highlight];
      highlight[i] = false;
      this.setState({highlight});
    }

    this.props.onChange(id)
  }

  render() {
    let normalStyle = {
      backgroundColor: 'var(--button-background-color)',
      color: 'var(--button-color)',
      padding: '8px 15px 0px 15px',
      display: 'flex',
      borderTopLeftRadius: '10px',
      borderTopRightRadius: '10px',
      height: '26px',
      cursor: 'pointer',
      border: '2px solid transparent'
    }

    let selectedStyle = JSON.parse(JSON.stringify(normalStyle));
    selectedStyle.backgroundColor = 'var(--panel-background-color)';
    selectedStyle.color = 'var(--panel-color)';

    let notifyNormalStyle = JSON.parse(JSON.stringify(normalStyle));
    notifyNormalStyle.color = 'var(--notification-background-color)';
    notifyNormalStyle.border = '2px solid var(--notification-background-color)';

    let barStyle:any = {
      backgroundColor: 'var(--panel-background-color)',
      borderRadius: 'var(--panel-border-radius)',
      borderTopLeftRadius: '0px',
      height: '10px',
      transform: 'translateY(-3px)',
      textAlign: 'right',
      padding: '0px 6px 0px 6px',
      cursor: 'pointer',
      display: 'flex',
      alignItems: 'center',
      justifyContent: 'right'
    }

    let isMobile = window.matchMedia('(max-width: 500px)').matches;

    let divs = [];
    let buttons = [];

    for(let i = 0; i < this.props.tabs.length; i++) {
      let tab = this.props.tabs[i];
      let active = (this.props.tab == tab.id);
      let style = active ? selectedStyle : normalStyle;

      // if(!active && this.state.highlight[i])
      //   style = notifyNormalStyle;

      let label = tab.name;
      // if(!active || (i > 0 && this.props.tabs.length > 4 && isMobile))
      //   label = <div style={{transform: 'translateY(2px)'}}>{tab.icon}</div>;

      divs.push(
        <div key={i} style={style} onClick={()=>this.onTab(tab.id)}>
          {label}
        </div>
      )

      if(active && tab.buttons) {
        buttons.push(
          <div key={i}>{tab.buttons}</div>
        )
      }
    }

    return (
      <div>
        <div className="site-page-row" style={{columnGap: '5px'}}>
          {divs}
        </div>
        <div style={barStyle}>
          {buttons}
        </div>
      </div>
    )
  }
}

export default TabPanel;